// extracted by mini-css-extract-plugin
module.exports = {"root":"_3ys8k","bg":"_30z06"};